import React from 'react';
import Head from 'next/head';
import Layout from 'components/layout';
import Header from 'components/banner';
import UseResize from 'utils/hooks/useResize';
import style from './index.module.scss';
import Contact from 'components/contact';
interface Props {
  title: string;
  pageKey: string;
  customClass?: string;
  children: React.ReactNode;
}
const Menu = [
  {
    link: '/about/about',
    text: '关于我们',
    key: 'about',
  },
  {
    link: '/about/contact',
    text: '联系我们',
    key: 'contact',
  },
];
const pcImage = 'https://devcdn.xylink.com/xylink_website_doc/images/replace/about/pc/pc-about-banner.jpg';
const mImage = 'https://devcdn.xylink.com/xylink_website_doc/images/replace/about/mobile/m-about-banner.jpg';
const Wrap = (props: Props) => {
  const { title, children, pageKey = 'about', customClass = '' } = props;
  const size = UseResize();
  return (
    <Layout>
      <Head>
        <title>{title}</title>
      </Head>
      <section>
        <Header bgImage={size.width < 768 ? mImage : pcImage} menu={Menu} pageKey={pageKey} title=" " />
        <div className={customClass}>{children}</div>
        <Contact className={style.contact} />
      </section>
    </Layout>
  );
};

export default Wrap;
